  const formatTo12HourTime = (timeStr) => {
    if (!timeStr) return "N/A";
    try {
      const [hour, minute] = timeStr.split(":");
      const d = new Date();
      d.setHours(parseInt(hour, 10), parseInt(minute, 10), 0);
      return d.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return timeStr;
    }
  };


  export default formatTo12HourTime;